import http from "./httpService";
import {Api, apiUrls} from "../../helpers/api";
import {PageableModel} from "../models/table";
import {CountryModel} from "../models/country";
import {AxiosResponse} from "axios";

export class CountryService {
    public static async getAll(): Promise<AxiosResponse<PageableModel<CountryModel>>> {
        return await http.get<PageableModel<CountryModel>>(`${Api.getUrl(apiUrls.dictionaries.countries)}?sort=name:asc`);
    }
}
